import { FC, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Typography } from '@mui/material';

import styles from './BlackToast.module.scss';

interface IProps {
  text?: string;
}

export const BlackToast: FC<IProps> = memo(({ text }) => {
  const { t } = useTranslation();

  return (
    <Box className={styles.blackToastWrapper}>
      <Typography className={styles.blackToastText} variant="subtitle2">
        {text || t('copiedLink')}
      </Typography>
    </Box>
  );
});
